// CJS require — Webpack 4 resolves to dist/index.cjs via mainFields; ESM import fails to get named exports from CJS.
const supabaseModule = require('@supabase/supabase-js');
const createClient = supabaseModule.createClient || supabaseModule.default?.createClient;

// Supabase: env vars override (use .env when you can). Fallbacks so app works without .env.
export const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || process.env.EXPO_PUBLIC_SUPABASE_URL || 'https://reaxskhhprrhpzbivcbh.supabase.co';
export const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || process.env.EXPO_PUBLIC_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJlYXhza2hocHJyaHB6Yml2Y2JoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjgzNDg1MTAsImV4cCI6MjA4MzkyNDUxMH0.ti4StV83VW9LADIQraYsYs1eoomUxBffRQWIM-pTf3A';

console.log('🔧 Initializing Supabase client...');

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: false,
    persistSession: false,
    detectSessionInUrl: false,
  },
  global: {
    headers: {},
  },
});

// Storage bucket names
export const STORAGE_BUCKETS = {
  PROFILE_PICTURES: 'profile-pictures',
  EVENT_IMAGES: 'event-images',
  HOTSPOT_PHOTOS: 'hotspot-photos',
  CLUB_EVIDENCE: 'club-evidence',
};

// Helper function to get public URL for a file
export const getPublicUrl = (bucket, path) => {
  const { data } = supabase.storage.from(bucket).getPublicUrl(path);
  return data?.publicUrl;
};

// Helper function to upload a file
export const uploadFile = async (bucket, path, file, options = {}) => {
  const { data, error } = await supabase.storage
    .from(bucket)
    .upload(path, file, {
      cacheControl: '3600',
      upsert: true,
      ...options,
    });
  
  if (error) {
    throw error;
  }
  
  return data;
};

// Helper function to delete a file
export const deleteFile = async (bucket, path) => {
  const { data, error } = await supabase.storage
    .from(bucket)
    .remove([path]);
  
  if (error) {
    throw error;
  }
  
  return data;
};

// Real-time subscription helper
export const subscribeToTable = (table, callback, filter = null) => {
  let channel = supabase
    .channel(`${table}-changes`)
    .on(
      'postgres_changes',
      {
        event: '*',
        schema: 'public',
        table: table,
        ...(filter && { filter }),
      },
      callback
    )
    .subscribe();
  
  return channel;
};

// Unsubscribe helper
export const unsubscribe = (channel) => {
  if (channel) {
    supabase.removeChannel(channel);
  }
};

export default supabase;

